// assets/js/team.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function initTeam(section) {
  if (!section || section.__teamInit) return;
  section.__teamInit = true;

  const eyebrow = section.querySelector(".team__eyebrow");
  const headline = section.querySelector(".team__headline");
  const topRight = section.querySelector(".team__top-right");
  const members = section.querySelectorAll(".team__member");

  gsap.set([eyebrow, headline, topRight], { opacity: 0, y: 18 });
  if (members.length) gsap.set(members, { opacity: 0, y: 18 });

  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: {
          trigger: section,
          start: "top 78%",
          once: true,
        },
      };

  const tl = gsap.timeline(tlOpts);

  if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 });
  if (headline) tl.to(headline, { opacity: 1, y: 0, duration: 0.7 }, "-=0.2");
  if (topRight) tl.to(topRight, { opacity: 1, y: 0, duration: 0.55 }, "-=0.35");

  if (members.length) {
    tl.to(
      members,
      { opacity: 1, y: 0, duration: 0.6, stagger: 0.12 },
      "-=0.25",
    );
  }

  if (!isEditor && members.length) {
    members.forEach((m) => {
      const fig = m.querySelector(".team__photo-fig");
      if (!fig) return;

      gsap.to(fig, {
        y: -10,
        ease: "none",
        scrollTrigger: {
          trigger: m,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.35,
        },
      });
    });
  }
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".team").forEach(initTeam);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () => root.querySelectorAll(".team").forEach(initTeam);

  run();

  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
